import {createFeatureFlagsStore} from '#imports';

export const FeatureFlags = [
    'new-events-page',
    'enable-page-cache',
    'new-resource-page',
    'martech-tech-trends-2026',
    'new-resource-card-in-collections',
    'new-resource-card-in-events',
    'new-resource-card-in-guides',
] as const;
export type FeatureFlag = (typeof FeatureFlags)[number];

/** Register features-flags at load
 * Store is initialized in `src/plugins/load-feature-flags`
 */
export const useFeatureFlagsStore = createFeatureFlagsStore([...FeatureFlags], 'resources-center-feature-flags-store');
